<div class="row">
  <div class="col-md-12 ka-em-footer">
    © 2004-{{ currentYear }} www.kaakateeya.com Matrimony - Online Marriage Site. All Rights Reserved.
  </div>
</div>
